const CONTENT_NOT_FOUND_PATTERNS = ['content not found', 'контент не найден', 'content.not.found'];

const normalize = (value: string) => value.toLowerCase().replaceAll('_', '.');

export const isContentNotFoundMessage = (value?: string | null) => {
  if (!value) {
    return false;
  }

  const message = normalize(value);

  return CONTENT_NOT_FOUND_PATTERNS.some((pattern) => message.includes(pattern));
};

export const isContentNotFoundError = (error: unknown) => {
  if (error instanceof Error) {
    const code = (error as Error & { errorCode?: unknown }).errorCode;
    return (
      isContentNotFoundMessage(`${error.name} ${error.message}`) ||
      (typeof code === 'string' && isContentNotFoundMessage(code))
    );
  }

  if (typeof error === 'string') {
    return isContentNotFoundMessage(error);
  }

  if (error && typeof error === 'object') {
    const maybeMessage = (error as { message?: unknown }).message;
    const maybeCode = (error as { code?: unknown }).code;

    if (typeof maybeMessage === 'string' && isContentNotFoundMessage(maybeMessage)) {
      return true;
    }

    if (typeof maybeCode === 'string' && isContentNotFoundMessage(maybeCode)) {
      return true;
    }
  }

  return false;
};

export const isContentNotFoundSentryEvent = (
  event: unknown,
  hint?: { originalException?: unknown }
) => {
  if (isContentNotFoundError(hint?.originalException)) {
    return true;
  }

  const maybeEvent = event as {
    message?: string;
    exception?: { values?: Array<{ value?: string; type?: string }> };
  };
  const exceptionValues = Array.isArray(maybeEvent?.exception?.values)
    ? maybeEvent.exception.values
    : [];
  const exceptionMessages = exceptionValues.flatMap(({ value, type }) =>
    [value, type].filter((item): item is string => Boolean(item))
  );
  const allMessages = [maybeEvent?.message, ...exceptionMessages].filter((item): item is string =>
    Boolean(item)
  );

  return allMessages.some(isContentNotFoundMessage);
};
